module.exports = __webpack_public_path__ + "images/illustrations/reach-icon-contractors-0f6d6f54c6beeb523c1dee37919e68e7.svg";